<template>
  <router-link
    :to="{
      name: 'Orders',
      params: { orderNumber: this.params.value },
    }"
    :target="target"
    class="text-blue-500 underline"
  >
    {{ params.value }}
  </router-link>
</template>

<script>
export default {
  name: "SourceOrderNumberLink",
  computed: {
    target() {
      if (this.params.target) {
        return this.params.target;
      }
      return "_self";
    },
  },
};
</script>
